/* jshint esversion: 6 */
import axios from 'axios';
import * as _ from 'underscore';

class Analytics {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
        this.intervalId = 0,
        this.hasStorage = (typeof(Storage) !== undefined) ? true : false;

        if (window.DlvrConstants !== undefined) {
            if (parseInt(window.DlvrConstants.ANALYTICS_COLLECTION)) {
                this.intervalId = window.setInterval(() => {
                    this.sendEvents();
                }, 5000);
            }
        }

        this.serializeEvents = (events) => {
            if (this.hasStorage) {
                window.localStorage.setItem('dlvr_events', JSON.stringify(events));
            }
        };

        this.unserializeEvents = () => {
            let serializedEvents = null,
                events = [];

            if (this.hasStorage && window.localStorage.getItem('dlvr_events')) {
                serializedEvents = window.localStorage.getItem('dlvr_events');

                events = JSON.parse(serializedEvents);
            }

            return events;
        }

    }

    sendEvents(final) {
        let eventsToSend = this.unserializeEvents();

        if (window.DlvrConstants !== undefined) {
            if (!parseInt(window.DlvrConstants.ANALYTICS_COLLECTION)) {
                return;
            }
        }

        if (this.apiUrl && eventsToSend.length) {
            axios({
                url: `${this.apiUrl}/analytics/record`,
                data: {
                    events: eventsToSend
                },
                headers: { "Content-type": "application/json" },
                method: 'POST',
                withCredentials: true,
                responseType: 'json'
            }).then(() => {
                this.serializeEvents([]);
            });
        }

        if (final) {
            window.clearInterval(this.intervalId);
        }

    }

    recordEvent(data) {
        let analyticsData = Object.assign({}, data),
            events = this.unserializeEvents(),
            datetime = moment();

        if (analyticsData.event_data === undefined) {
            analyticsData.event_data = {};
        }

        // the campaign the visit came from, from any utm_ params in the address
        new URLSearchParams(window.location.search).forEach((value, key) => {
            if (key.startsWith('utm_')) {
                analyticsData.event_data[key] = value;
            }
        });

        // timestamp the event
        analyticsData.event_date = datetime.unix();

        // add page info to each request so the requests don't have to sweat it
        analyticsData.event_data.host = window.location.host;
        analyticsData.event_data.path = window.location.pathname;
        analyticsData.event_data.agent = window.navigator.userAgent;

        // serialize the event data for the DB JSON column
        analyticsData.event_data = analyticsData.event_data;

        if (!events.find((eventData) => {
            return eventData.event_name === analyticsData.event_name && _.isEqual(eventData.event_data, analyticsData.event_data);
        })) {
            events.push(analyticsData);
        }

        this.serializeEvents(events);

    }
}

export default Analytics;
